import { OrderMethod } from '../../../../../services/exports/Constants';

export default {
  [OrderMethod.Pickup]: 'Ritiro',
  [OrderMethod.Delivery]: 'Consegna',
  [OrderMethod.OnSite]: 'In loco',
};
